import React, { useState } from "react";
import axios from "axios";

const ImageUploader = ({ onUpload }) => {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleUpload = async () => {
    if (!image) return;

    setUploading(true);
    const formData = new FormData();
    formData.append("file", image);
    formData.append("upload_preset", "lazerzone"); // ✅ Tu Upload Preset

    try {
      const res = await axios.post(
        "https://api.cloudinary.com/v1_1/dnzpehgui/image/upload", // ✅ Tu Cloud Name
        formData
      );
      const imageUrl = res.data.secure_url;
      onUpload(imageUrl); // ✅ Llama al callback para guardar el URL
    } catch (err) {
      console.error("Error al subir imagen:", err);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex flex-col gap-4 items-center">
      <input type="file" accept="image/*" onChange={handleImageChange} />
      {preview && <img src={preview} alt="Preview" className="w-32 rounded" />}
      <button
        onClick={handleUpload}
        disabled={uploading}
        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
      >
        {uploading ? "Subiendo..." : "Subir imagen"}
      </button>
    </div>
  );
};

export default ImageUploader;
